import { motion, AnimatePresence } from "motion/react";
import { Moon, RotateCcw, Sun, Sunrise, Sunset } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { t } from "@/lib/i18n";
import type { Lang } from "@/lib/i18n";
import type { PhaseControl } from "@/hooks/usePhase";

const ICONS: Record<string, LucideIcon> = {
  morning: Sunrise,
  afternoon: Sun,
  dusk: Sunset,
  night: Moon,
};

/** Shows the active phase; click to preview the next one, reset to follow time. */
export function PhaseToggle({ phase, isAuto, cycle, resetAuto, lang }: PhaseControl & { lang: Lang }) {
  const Icon = ICONS[phase.id] ?? Sun;

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={cycle}
        title={lang === "pt" ? "mudar a hora do dia" : "change time of day"}
        className="flex items-center gap-2"
        style={{
          background: "var(--tc-paper)",
          border: "1px solid var(--tc-line-2)",
          borderRadius: 999,
          cursor: "pointer",
          padding: "5px 12px 5px 10px",
          color: "var(--tc-ink-strong)",
          fontFamily: "var(--tc-mono)",
          fontSize: 11,
          letterSpacing: "0.1em",
          textTransform: "uppercase",
        }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={phase.id}
            initial={{ rotate: -90, opacity: 0, scale: 0.6 }}
            animate={{ rotate: 0, opacity: 1, scale: 1 }}
            exit={{ rotate: 90, opacity: 0, scale: 0.6 }}
            transition={{ duration: 0.3 }}
            style={{ display: "inline-flex", color: "var(--tc-brass)" }}
          >
            <Icon size={15} />
          </motion.span>
        </AnimatePresence>
        {t(phase.label, lang)}
      </button>

      {!isAuto && (
        <button
          onClick={resetAuto}
          title={lang === "pt" ? "seguir a hora real" : "follow real time"}
          aria-label={lang === "pt" ? "seguir a hora real" : "follow real time"}
          style={{ background: "none", border: "none", cursor: "pointer", color: "var(--tc-faint)", display: "inline-flex", padding: 2 }}
        >
          <RotateCcw size={14} />
        </button>
      )}
    </div>
  );
}
